import {
    CodepenIcon,
    LandPlot,
    Layers3Icon,
    MagnetIcon,
    Scale3D,
    TestTubeDiagonal,
} from 'lucide-react';

// DICOM General Series Modality Attribute (0008,0060)
export enum Modality {
    CT = 'CT',
    MR = 'MR',
    REG = 'REG',
    PT = 'PT',
    RTSTRUCT = 'RTSTRUCT',
    RTPLAN = 'RTPLAN',
    RTDOSE = 'RTDOSE',
    UNKNOWN = 'UNKNOWN',
}

export enum StorageSOPClassUID {
    CTImageStorage = '1.2.840.10008.5.1.4.1.1.2',
    MRImageStorage = '1.2.840.10008.5.1.4.1.1.4',
    PETImageStorage = '1.2.840.10008.5.1.4.1.1.128',
    SpatialRegistrationStorage = '1.2.840.10008.5.1.4.1.1.66.1',
    RTDoseStorage = '1.2.840.10008.5.1.4.1.1.481.2',
    RTStructureSetStorage = '1.2.840.10008.5.1.4.1.1.481.3',
}

export function strToModality(val: string): Modality {
    const e = Modality[val as keyof typeof Modality];
    if (e === undefined) {
        return Modality.UNKNOWN;
    }
    return Modality[e];
}

export function isImageModality(modality: Modality): boolean {
    return (
        modality === Modality.CT ||
        modality === Modality.MR ||
        modality === Modality.PT
    );
}

export function getModalityColor(type: Modality): string {
    switch (type) {
        case Modality.CT:
            return 'primary.main';
        case Modality.MR:
            return 'secondary.main';
        case Modality.RTSTRUCT:
            return 'info.main';
        case Modality.RTDOSE:
            return 'warning.main';
        case Modality.RTPLAN:
            return 'success.main';
        default:
            return 'text.secondary';
    }
}

export function getModalityIcon(type: Modality, size = 16) {
    switch (type) {
        case Modality.RTSTRUCT:
            return <CodepenIcon size={size} />;
        case Modality.CT:
            return <Layers3Icon size={size} />;
        case Modality.MR:
            return <MagnetIcon size={size} />;
        case Modality.RTDOSE:
            return <TestTubeDiagonal size={size} />;
        case Modality.RTPLAN:
            return <LandPlot size={size} />;
        case Modality.REG:
            return <Scale3D size={size} />;
        default:
            return null;
    }
}
